import axios from "axios";
import * as types from "./actionTypes";
const base_url = process.env.REACT_APP_BASE_URL

// Login User
export const login = (email, password) => async (dispatch) => {
    
    dispatch({ type: types.LOGIN_REQUEST });

    try {
        let apiURL, tokenName, refreshTokenName;
        const currentPath = window.location.pathname;

        // Determine API and token names based on the current path
        if (currentPath === "/admin/login") {
            
            apiURL = `${base_url}/admin/login`;
            tokenName = "admin_access";
            refreshTokenName = "admin_refresh_token";

        } else if (currentPath === "/distributor/login") {
            
            apiURL = `${base_url}/distributors/login`;
            tokenName = "distributor_access";
            refreshTokenName = "distributor_refresh_token";
        }

        // Make API request
        const res = await axios.post(apiURL, { email, password });

        // Extract message from response
        const { message } = res.data;

         // Log the message to verify
         console.log("redux: ", message);

        // Extract token and refresh_token from the data object
        const { token, refresh_token } = res.data.data;

       

        // Store tokens in localStorage
        localStorage.setItem(tokenName, token);
        localStorage.setItem(refreshTokenName, refresh_token);

        // Dispatch LOGIN_SUCCESS and pass the success message
        dispatch({
            type: types.LOGIN_SUCCESS,
            payload: { token, message },
        });
        console.log("Login token Name: ", tokenName);

        // Load user with the tokenName
        dispatch(loadUser(tokenName));

    } catch (error) {
        dispatch({
            type: types.LOGIN_FAILURE,
            payload: error.response?.data?.message || error.message,
        });
    }
};


export const loadUser = (tokenName) => async (dispatch) => {
    
    dispatch({ type: types.LOAD_USER_REQUEST });

    try {
        let apiURL, token;

        // Get current pathname to determine whether it's admin or distributor
        const currentPath = window.location.pathname;

        if (currentPath.includes("/admin")) {

            apiURL = `${base_url}/admin/profile`;
            token = localStorage.getItem("admin_access");

        } else if (currentPath.includes("/distributor")) {

            apiURL = `${base_url}/distributors`;
            token = localStorage.getItem("distributor_access");
        }

        if (!token) {
            throw new Error("No token found");
        }

        const res = await axios.get(apiURL, {
            headers: {
                Authorization: `Bearer ${token}`, // Make sure to use `Bearer` for token in Authorization header
            },
        });

        dispatch({ type: types.LOAD_USER_SUCCESS, payload: res.data });

    } catch (error) {
        
        dispatch({ type: types.LOAD_USER_FAILURE, payload: error.message });
    }
};

export const logoutUser = () => (dispatch) => {

    // Clear both admin and distributor tokens
    localStorage.removeItem("admin_access");
    localStorage.removeItem("admin_refresh_token");

    localStorage.removeItem("distributor_access");
    localStorage.removeItem("distributor_refresh_token");

    dispatch({ type: "LOGOUT" });

    // Determine where to navigate based on the current path
    if (window.location.pathname.includes("/distributor")) {

        window.location.href = "/distributor/login";
    } else {

        window.location.href = "/admin/login";
    }
};